import React from 'react';

import { map, sum, range } from 'lodash';
import { 
  degreesToRadians, 
  circlePathDef, 
  slicePathDef,
  getDetailedChart,
  getDetailedCells,
  getBandPath,
  getCellPath,
} from '../../core/utils';

class PreviewChart extends React.PureComponent {

  render() {
    const { 
      chart,
      generations,
      palette,
    } = this.props;

    const dChart = getDetailedChart(chart, generations);
    const cells = getDetailedCells([], generations, dChart);
    
    const width = dChart.minX + dChart.maxX;
    const height = dChart.minY + dChart.maxY + 40;

    return (
      <div style={{width: width + 'px', height: height + 'px'}}>
        <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
          <g transform={`translate(${dChart.minX}, ${dChart.minY})`}>
            {range(0, chart.generations).map(g => {
              const n = Math.pow(2, g);
              const gColors = palette.colors[g % palette.colors.length];
              return (
                range(0, n).map(i => {
                  const cell = cells[n + i - 1];
                  const cellPath = getCellPath(cell);
                  const bandPath = getBandPath(cell, 30);
                  const color = gColors[i % gColors.length];    
                  return (
                    <path key={i} d={cellPath} fill={color.background} strokeWidth={chart.strokeWidth} stroke={chart.strokeColor} />
                  )
                })
              )
            })}
            {range(0, chart.generations).map(g => {
              const n = Math.pow(2, g);
              const gColors = palette.colors[g % palette.colors.length];
              return (
                range(0, n).map(i => {
                  const cell = cells[n + i - 1];
                  const bandPath = getBandPath(cell, 20);
                  const color = gColors[i % gColors.length];    
                  return (
                    color.bandColor && <path key={i} d={bandPath} fill={color.bandColor} />
                  )
                })
              )
            })}

          </g>
        </svg>
      </div>
    )
  }
}
export default PreviewChart;


// WEBPACK FOOTER //
// ./src/components/fanchart/preview.js